import $ from 'cash-dom'
import { mobileHeader } from './header-mobile'
import { lockScroll } from '../utilities/scroll-lock'

$('[data-action="open-modal"]').on('click', function (e) {
  e.preventDefault()
  lockScroll()
  $('modal-panel').attr('aria-hidden', 'true')
  let hasVideo = this.getAttribute('data-modal-videos')
  let modalId = this.getAttribute('data-modal-id')
  let modal = $(`#${modalId}`)

  $('body').addClass('modal-blur')

  // Create or reuse a hidden placeholder right before the modal
  let $placeholder = $(`[data-element="data-sticky-placeholder-${modalId}"]`)
  if (!$placeholder.length) {
    $placeholder = $(
      `<div style="display:none" data-sticky-placeholder data-element="data-sticky-placeholder-${modalId}"></div>`
    )
    modal.before($placeholder)
  }

  // Move modal to body
  modal
    .attr({ 'aria-hidden': 'false', 'data-state': 'show' })
    .show()
    .appendTo(document.body)

  // Search panel gets some special treatment
  let searchInput = modal.find('[data-element="search-input"]')
  if (searchInput.length > 0) {
    searchInput[0].focus()
  }

  if (modalId == 'search-modal') {
    mobileHeader.hide()
  }
  if (hasVideo === 'true') {
    playVideos(modalId)
  }
})

$('[data-action="close-modal"]').on('click', function (e) {
  e.preventDefault()
  closeModal(this)
  pauseVideos(this)
})

$('[data-element="search-input"]').on('keydown', function (e) {
  if (e.key === 'Escape') {
    closeModal(this)
    pauseVideos(this)
  }
})

const closeModal = (element) => {
  $('body').removeClass('modal-blur')
  unlockScroll()

  // Find the modal element (note: it's a <modal-panel> custom element)
  const $modal = $(element).closest('modal-panel')
  if (!$modal.length) return

  const modalId = $modal.attr('id')
  const $placeholder = $(`[data-element="data-sticky-placeholder-${modalId}"]`)

  // Restore modal to its original place and remove the placeholder
  if ($placeholder.length) {
    $placeholder.replaceWith($modal)
  }

  $modal.attr({ 'aria-hidden': 'true', 'data-state': 'hidden' }).hide()

  // Optional: if you hid UI on open, restore here
  if (modalId === 'search-modal' && typeof mobileHeader?.show === 'function') {
    mobileHeader.show()
  }
}

const playVideos = (modalId) => {
  let mp4Video = $(`#${modalId} video`)[0]
  if (mp4Video != null) {
    mp4Video.play()
  }

  let vimeoVideo = $(`#${modalId} .js-vimeo-video`)[0]
  if (vimeoVideo != null) {
    const player = new window.VimeoPlayer(vimeoVideo)
    player.play()
  }
}

const pauseVideos = (modalPanel) => {
  // Stop mp4 video if it has it
  let mp4Video = modalPanel.find('video')[0]
  if (mp4Video != null) {
    mp4Video.pause()
  }

  // Stop Vimeo video if it has it
  let vimeoVideo = modalPanel.find('.js-vimeo-video')[0]
  if (vimeoVideo != null) {
    const player = new window.VimeoPlayer(vimeoVideo)
    player.pause()
  }
}

export { closeModal }
